import React from 'react';

interface Props {
  value: string | null | undefined;
  buttons?: React.ReactNode;
  flexWrap?: boolean;
}

const titleColor = '#2592C8';

const MainTitle = (props: Props) => {
  return (
    <div>
      <style>
        {`
          .main-title-wrap {
            display: flex;
            justify-content: space-between;
            font-size: 15px;
            margin-bottom: 25px;
          }
          @media screen and (max-width: 814px) {
            .main-title-wrap.flex-wrap {
              flex-wrap: wrap;
            }
          }
          .main-title {
            font-size: 1.5em;
            font-weight: bold;
            color: ${titleColor};
          }
          @media screen and (max-width: 814px) {
            .main-title.with-flex-wrap {
              margin-bottom: 10px;
            }
          }
        `}
      </style>
      <div className={props.flexWrap ? 'main-title-wrap flex-wrap' : 'main-title-wrap'}>
        <h1 className={props.flexWrap ? 'main-title with-flex-wrap' : 'main-title'}>{props.value}</h1>
        <div style={{ padding: '0 20px 0 0' }}>{props.buttons}</div>
      </div>
    </div>
  );
};
export default MainTitle;
